// Shared className for a job/video status pill — used by VideoPage (single video)
// and AdminUserJobsPage (admin's per-user jobs table). 'completed' (and anything
// else not explicitly called out) gets the base class with no modifier.
export function statusBadgeClass(status: string): string {
  switch (status) {
    case 'failed':
      return 'status-badge status-badge--failed';
    case 'cancelled':
      return 'status-badge status-badge--cancelled';
    case 'completed':
      return 'status-badge';
    default:
      return 'status-badge status-badge--processing';
  }
}
